import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { MailCheck, UserPlus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { NeuButton, NeuInput } from "../../components/neu/Neu";
import { requestSeats } from "../../api/seats";

// Count only — no price, no checkout inside the app (App Store / Play policy).
export const SeatUpgradeDialog = ({ open, onOpenChange }) => {
  const { t } = useTranslation();
  const [extra, setExtra] = useState(1);
  const [state, setState] = useState("ask");
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    const count = Number(extra);
    if (!count || count < 1) return toast.error(t("seats.invalidCount"));
    setBusy(true);
    try {
      await requestSeats(count);
      setState("sent");
    } catch {
      toast.error(t("seats.failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-3xl" data-testid="seat-upgrade-dialog">
        <DialogHeader>
          <DialogTitle className="text-start text-lg font-black">{t("seats.title")}</DialogTitle>
        </DialogHeader>
        {state === "ask" ? (
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">{t("seats.limitReached")}</p>
            <div>
              <p className="label-xs mb-1">{t("seats.howMany")}</p>
              <NeuInput
                data-testid="seat-extra"
                type="number"
                min={1}
                max={500}
                value={extra}
                onChange={(e) => setExtra(e.target.value)}
              />
            </div>
            <NeuButton
              variant="primary"
              className="flex w-full items-center justify-center gap-2"
              data-testid="seat-confirm"
              disabled={busy}
              onClick={confirm}
            >
              <UserPlus className="h-4 w-4" />
              {t("seats.confirm")}
            </NeuButton>
          </div>
        ) : (
          <div className="space-y-3 text-center" data-testid="seat-sent">
            <MailCheck className="mx-auto h-12 w-12 text-emerald-600" />
            <p className="text-base font-bold text-foreground">{t("seats.emailSent")}</p>
            <p className="text-sm text-muted-foreground">{t("seats.emailHint")}</p>
            <NeuButton className="w-full" data-testid="seat-close" onClick={() => onOpenChange(false)}>
              {t("common.close")}
            </NeuButton>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
